import { render, staticRenderFns } from "./AgreedProtocol.vue?vue&type=template&id=21f33bd4&scoped=true"
import script from "./AgreedProtocol.vue?vue&type=script&lang=js"
export * from "./AgreedProtocol.vue?vue&type=script&lang=js"
import style0 from "./AgreedProtocol.vue?vue&type=style&index=0&id=21f33bd4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_5a3c64a85473ede7d9205802ebc6db0e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f33bd4",
  null
  
)

export default component.exports